import React from 'react';
import { OutlineArrowRight } from '@producer/ui-kit';
import { BackButton } from '../../settings/components/settings-page-layout';

import styles from './description-header.module.scss';
type DescriptionHeaderProps = {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  onBack?: () => void;
};

export const DescriptionHeader: React.FC<DescriptionHeaderProps> = ({
  title,
  description,
  actions,
  onBack,
}) => (
  <div className={styles['container']}>
    {title && (
      <div className={styles['header']}>
        <div className={styles['title-container']}>
          {onBack && (
            <BackButton onClick={onBack}>
              <OutlineArrowRight />
            </BackButton>
          )}

          <h2 className={styles['title']}>{title}</h2>
        </div>

        {actions && <div className={styles['actions']}>{actions}</div>}
      </div>
    )}

    {description && (
      <p
        className={styles['description']}
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    )}
  </div>
);
